<template>
  
  <div class="panel panel-default">
      <div class="panel-heading">
          <h2>Users</h2>

          <router-link class="btn btn-default pull-right" to="/vue/manage/users/0" title="Create a new user">
              <span class="glyphicon glyphicon-user" aria-hidden="true"></span> New User
          </router-link>
      </div>
    
    <div class="panel-body">
      
      <table class="table">
        <thead>
        <tr>
          <th scope="col"><!--edit--></th>
          <th scope="col">Name</th>
          <th scope="col">Username</th>
          <th scope="col">Email</th>
          <th scope="col"><!--reset password--></th>
        </tr>
        </thead>
        <tbody>
        
        <tr v-for="u in users">
            <th scope="row">
                <router-link class="btn btn-default btn-sm" :to="{name: 'userAddEdit', params:{id: u.id, user:selectedUser}}" :title="`Edit user ` + u.name">
                    <span class="glyphicon glyphicon-option-horizontal" aria-hidden="true"></span>
                </router-link>
            </th>
          <td>{{ u.name }}</td>
          <td>{{ u.username }}</td>
          <td>{{u.email}}</td>
          <td>
            <button type="button" class="btn btn-secondary btn-sm pull-right" @click="confirmReset(u)" 
                    :disabled="!u.email" :title="u.email ? 'Reset Password': 'User must have an email before resetting password'">
              Reset Password
            </button>
          </td>
        </tr>
        
        </tbody>
      </table>
    </div>
  </div>
  
  <!--reset password confirmation modal -->
  <div class="modal fade" id="password_reset_confirmation_modal" role="dialog" aria-modal="true" aria-labelledby="resetModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
          <h2 class="modal-title" id="resetModalTitle">Reset Password</h2>
        </div>
        
        <div class="modal-body">

          <div class="container" style="width: inherit; padding:15px" v-if="!passwordReset">
              An email with the password will be sent to <strong>{{selectedUser.email}}</strong>.
          </div>

          <div class="alert alert-danger" role="alert" v-if="resetError">
            <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
            <span class="sr-only">Error:</span>
            {{ resetError }}
          </div>

          <div class="alert alert-info" role="alert" v-if="passwordReset">
            <span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span>
            <span class="sr-only">Info:</span>
            You've successfully reset the password for this user. We've emailed the password to <strong>{{selectedUser.email}}</strong>.
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="resetPassword()" :disabled="passwordReset">Reset</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        </div>
        
      </div>
    </div>
  </div>

</template>

<script setup>
   import { ref } from 'vue';
   import { storeToRefs } from "pinia";
   import { manageUserStore } from '@/stores/managedusers.store';
   import {useLoading} from "vue-loading-overlay";
   
   const $loading = useLoading();
     
   const store = manageUserStore();
  
   const { users } = storeToRefs(store);
   
   const selectedUser = ref({name:'new user'});
   const passwordReset = ref(false);
   const resetError = ref('');
   
   function confirmReset(user){
     selectedUser.value = user;
     passwordReset.value = false;
     resetError.value = "";
     
     $('#password_reset_confirmation_modal').modal('show');
   }
   
   async function resetPassword(){
     resetError.value = "";
     passwordReset.value = false;
     const l = $loading.show();
     
     try{
       passwordReset.value = await store.resetPassword(selectedUser.value);  
     }
     catch (e){
       resetError.value = e;
     }

     l.hide();
   }

   const loader = $loading.show();

   store.loadUsers()
       .then(loader.hide);

</script>

<style scoped>
  h2{
    display: inline-block; 
    margin: 0;
  }
  th{
    font-weight:bold;
  }
</style>